import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./pages/Login";
import DashboardLayout from "./layout/DashboardLayout";  // new layout
import Dashboard from "./pages/Dashboard"; // new dashboard page
import Users from "./pages/Users";
import AIRecordings from "./pages/AIRecordings";
import ProtectedRoute from "./routes/ProtectedRoute";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        
        {/* Dashboard layout wraps all /dashboard/* */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute roles={["it_admin", "admin", "user", "agent"]}>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          {/* Dashboard main page at /dashboard */}
          <Route index element={<Dashboard />} />

          {/* Other nested routes */}
          <Route
            path="users"
            element={
              <ProtectedRoute roles={["it_admin", "admin"]}>
                <Users />
              </ProtectedRoute>
            }
          />
          <Route path="ai-recordings" element={<AIRecordings />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}